export const shareableInsights = [
  'content-snapshot',
  'language-snapshot',
  'recruiting-performance',
  'job-performance-report',
  'compliance-report',
  'employer-brand-report',
];
